export default __webpack_public_path__ + "static/media/investment.120388ef.svg";